<template>
    <div>
        <router-view></router-view>
    </div>
</template>
  
<script>
export default {
    name: 'taskPage',
    data() {
        return {
        }
    },
    methods: {

    },
}
</script>